var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83301 17.4168C1.83301 18.9752 3.02467 20.1668 4.58301 20.1668H17.4163C18.9747 20.1668 20.1663 18.9752 20.1663 17.4168V10.0835H1.83301V17.4168ZM17.4163 3.66683H15.583V2.75016C15.583 2.20016 15.2163 1.8335 14.6663 1.8335C14.1163 1.8335 13.7497 2.20016 13.7497 2.75016V3.66683H8.24967V2.75016C8.24967 2.20016 7.88301 1.8335 7.33301 1.8335C6.78301 1.8335 6.41634 2.20016 6.41634 2.75016V3.66683H4.58301C3.02467 3.66683 1.83301 4.8585 1.83301 6.41683V8.25016H20.1663V6.41683C20.1663 4.8585 18.9747 3.66683 17.4163 3.66683Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.02422820b49dc1bcfdc23dff38537916.svg";
export { ForwardRef as ReactComponent };